import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="10"
		height="2"
		fill="none"
		viewBox="0 0 10 2"
		{...props}
	>
		<path
			stroke="var(--svg-color, currentColor)"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M1 1h8"
		/>
	</svg>
);

export { SvgComponent as MinusIcon };
